module.exports = __webpack_public_path__ + "assets/img/41.c433ab86.png";